import { AccountSelect } from '@components'

import { Divider, FormItem, Space } from '@billy/design-system'
import { ReactElement, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useMatch, useMultiplePayableSubjects, usePaymentModal } from '../../../paymentReconciliationModal/contexts'
import { SubjectSummary } from '../../../paymentReconciliationModal/elements/SubjectSummary'
import { CrossCurrencyPaymentAmount } from '../BankLinesModalBody/elements/CrossCurrencyPaymentAmount'
import { DifferenceSelector } from '../DifferenceSelector'
import { LinkToBankLinesModal } from './elements/LinkToBankLinesModal'
import { ReconciliationSuggestion } from './elements/ReconciliationSuggestion'

export const MatchModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { hasMatchDifference, matchDifference, matchSuggestion } = useMatch()
  const { setSelectedSubjects, setSelectedSubjectsIds, initialSubject } = useMultiplePayableSubjects()
  const { isCrossCurrency, selectedAccount } = usePaymentModal()
  const displayDifferenceSelector = useMemo(
    () => hasMatchDifference && !isCrossCurrency,
    [hasMatchDifference, isCrossCurrency],
  )

  const accountCurrencyId = selectedAccount?.currencyId

  useEffect(() => {
    if (initialSubject && initialSubject?.id) {
      setSelectedSubjects?.([initialSubject])
      setSelectedSubjectsIds?.([initialSubject.id])
    }
  }, [initialSubject, setSelectedSubjects, setSelectedSubjectsIds])

  return (
    <>
      <SubjectSummary />
      <Space />
      <Divider />
      <Space />
      {isCrossCurrency && (
        <>
          <CrossCurrencyPaymentAmount
            convertedCurrencyId={accountCurrencyId}
            subjectCurrencyId={initialSubject?.currencyId}
          />
          <Space />
        </>
      )}
      <FormItem label={t('account')}>
        <AccountSelect disabled selectedId={matchSuggestion?.account_id} />
      </FormItem>
      <Space />
      <ReconciliationSuggestion matchSuggestion={matchSuggestion} />
      {displayDifferenceSelector && <DifferenceSelector difference={matchDifference} />}
      <LinkToBankLinesModal />
    </>
  )
}
